import { createRef } from 'react';
import sortBy from 'lodash/sortBy';
import { createSelector } from 'reselect';

export const dropdownSelectedProfile = (state) =>
  state?.filter?.dropdownSelectedProfile;
export const availableFilterProfiles = (state) => state?.filter?.profiles;
export const getFilterSettings = (state) => state?.ioc?.filterSettings;
export const getUserTags = (state) =>
  (state?.ioc?.filterSettings && state?.ioc?.filterSettings?.tags) || [];

export const selectFilterSettings = createSelector(
  getFilterSettings,
  (filterSettings) => {
    const res = { ...filterSettings };

    if (filterSettings?.feedsources) {
      res.feedsources = filterSettings?.feedsources?.map((source) => ({
        text: source?.name,
        value: source?.uuid,
        type: source?.type,
      }));
    }
    if (filterSettings?.vendors) {
      res.vendors = filterSettings?.vendors?.map((vendor) => ({
        text: vendor,
        value: vendor,
      }));
    }
    return res;
  },
);

export const selectFilterIndicators = createSelector(
  selectFilterSettings,
  (filterSettings) => {
    let res = [];

    const createChildren = (children = []) => {
      return (
        (children &&
          children?.map((child) => ({
            value: child?.dbAttribute,
            label: child?.indicatorName,
          }))) ||
        []
      );
    };

    if (filterSettings?.groupedIndicators) {
      res = filterSettings?.groupedIndicators?.map((item) => ({
        label: item?.groupName,
        value: item?.groupName,
        children: createChildren(item?.indicators),
      }));
    }

    return res;
  },
);

export const selectFeedItemFields = createSelector(
  selectFilterSettings,
  (filterSettings) => {
    let res = [];

    if (filterSettings?.feedItemFields) {
      res = [
        {
          value: null,
          label: '',
        },
      ];
      filterSettings.feedItemFields.forEach((item) => {
        res.push({
          value: item,
          label: item,
        });
      });
    }
    return res;
  },
);

export const selectOptionsByIndicator = createSelector(
  selectFilterSettings,
  (filterSettings) => {
    let res = {};

    if (filterSettings?.groupedIndicators) {
      filterSettings.groupedIndicators.forEach((item) => {
        item.indicators.forEach((subItem) => {
          const key = subItem?.dbAttribute;
          const options = subItem?.options?.map((option) => ({
            // the filters could be a list of jsons or list of strings
            value: typeof option == 'object' ? option?.value : option,
            label: typeof option == 'object' ? option?.label : option,
          }));
          const operators = subItem?.operator?.map((option) => ({
            value: option,
            label: option,
          }));
          res[key] = {
            ...subItem,
            options,
            operators,
          };
        });
      });
    }

    return res;
  },
);

export const selectFilterProfiles = (profiles) => {
  return profiles?.map((profile) => {
    const profileObject = { ...profile };

    if (profile?.condition_blocks?.length) {
      profileObject.condition_blocks = sortBy(
        profile?.condition_blocks,
        'position',
      )?.map((block) => {
        const conditions = sortBy(block?.conditions, 'position')?.map(
          (condition) => ({
            uuid: condition?.uuid,
            name: condition?.name,
            binary_operator: condition?.binary_operator,
            position: condition?.position,
            indicator: condition?.indicator,
            operator: condition?.operator,
            value: condition?.value,
            type: condition?.type,
            relative_indicator: null,
            ref: createRef(),
            id: condition?.uuid,
          }),
        );
        return {
          // ...block,
          uuid: block?.uuid,
          binary_operator: block?.binary_operator,
          position: block?.position,
          conditions,
        };
      });
    }
    profileObject.name = profile?.name;
    profileObject.uuid = profile?.uuid;

    return profileObject;
  });
};
